import ConstructorIOClient from '@constructor-io/constructorio-client-javascript'
import { getConstructorIndex } from '../helpers/constructor'

const constructorClientInstances = new Map<string, ConstructorIOClient>()
const constructorNodeInstances = new Map<string, any>()

export const getConstructorInstanceClientSide = () => {
  const key = 'clientSide'

  if (!constructorClientInstances.has(key)) {
    constructorClientInstances.set(key, new ConstructorIOClient({ apiKey: getConstructorIndex() }))
  }

  return constructorClientInstances.get(key)!
}

export const getConstructorInstanceServerSide = () => {
  // the window condition is required to not have an error of trying to require this library in client side and breaking the build
  const ConstructorIONode =
    typeof window === 'undefined' ? require('@constructor-io/constructorio-node') : null
  const key = `serverSide`

  if (!constructorNodeInstances.has(key)) {
    constructorNodeInstances.set(key, new ConstructorIONode({ apiKey: getConstructorIndex() }))
  }

  return constructorNodeInstances.get(key)!
}
